import React from "react";

const TreeNext: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 1024 1024"
    width={200}
    height={200}
    className="icon"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M768 651.636364a162.909091 162.909091 0 1 0 0 325.818181 162.909091 162.909091 0 0 0 0-325.818181z m0 93.090909a69.818182 69.818182 0 1 1 0 139.636363 69.818182 69.818182 0 0 1 0-139.636363zM837.818182 93.090909a46.545455 46.545455 0 0 1 46.545454 46.545455v279.272727a46.545455 46.545455 0 0 1-46.545454 46.545454h-651.636364a46.545455 46.545455 0 0 1-46.545454-46.545454v-279.272727a46.545455 46.545455 0 0 1 46.545454-46.545455h651.636364zM791.272727 186.181818H232.727273v186.181818h558.545454V186.181818z" />
    <path d="M418.909091 372.363636a46.545455 46.545455 0 0 1 45.800727 38.167273l0.744727 8.378182v372.363636h186.181819a46.545455 46.545455 0 0 1 8.378181 92.346182L651.636364 884.363636h-186.181819a93.090909 93.090909 0 0 1-92.439272-82.199272L372.363636 791.272727v-372.363636A46.545455 46.545455 0 0 1 418.909091 372.363636z" />
  </svg>
);

export default TreeNext;
